import { z } from 'zod';

const funnelRouteTargetSchema = z
    .object({
        page_id: z.number(),
        label: z.string().optional(),
    })
    .nullable();

const funnelPageRoutingSchema = z
    .object({
        on_purchase: funnelRouteTargetSchema,
        on_skip: funnelRouteTargetSchema,
    })
    .nullable();

export const funnelPageEditorSchema = z.object({
    referencePageId: z.number().nullable(),
    topBannerText: z.string(),
    funnelPriceInput: z.string(),
    funnelCtaText: z.string(),
    routing: funnelPageRoutingSchema,
});

export type FunnelPageEditorFormValues = z.infer<typeof funnelPageEditorSchema>;
